/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * allowed integrations of payment providers
 * @export
 */
export const PaypalPaymentSource = {
    Paypal: 'PAYPAL',
    Sofort: 'SOFORT',
    Giropay: 'GIROPAY',
    Card: 'CARD'
} as const;
export type PaypalPaymentSource = typeof PaypalPaymentSource[keyof typeof PaypalPaymentSource];


export function PaypalPaymentSourceFromJSON(json: any): PaypalPaymentSource {
    return PaypalPaymentSourceFromJSONTyped(json, false);
}

export function PaypalPaymentSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaypalPaymentSource {
    return json as PaypalPaymentSource;
}

export function PaypalPaymentSourceToJSON(value?: PaypalPaymentSource | null): any {
    return value as any;
}

